import React, {useState} from "react";
import {Box, Tab, Tabs, Typography} from "@mui/material";
import {pageAuthorizedByGroup} from "../../fragments/PageAuthorization";
import {ExtractorSetsTab} from "./components/ExtractorSetsTab";
import {ValidatorSetsTab} from "./components/ValidatorSetsTab";
import {ExporterSetsTab} from "./components/ExporterSetsTab";
import {OnChangeHandlerSetsTab} from "./components/OnChangeHandlerSetsTab";

function AdminSetsPageContent() {
	const [tab, setTab] = useState(0);

	return (
		<Box sx={{p: 3}}>
			<Typography variant="h5" gutterBottom>Configuration Sets</Typography>
			<Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{mb: 2}}>
				<Tab label="Extractor Sets" />
				<Tab label="Validator Sets" />
				<Tab label="Exporter Sets" />
				<Tab label="OnChange Handler Sets" />
			</Tabs>
			{tab === 0 && <ExtractorSetsTab />}
			{tab === 1 && <ValidatorSetsTab />}
			{tab === 2 && <ExporterSetsTab />}
			{tab === 3 && <OnChangeHandlerSetsTab />}
		</Box>
	);
}

export const AdminSetsPage = pageAuthorizedByGroup(AdminSetsPageContent, ["Admin"]);